import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CustomerVehicleSearchScreenActionSettingModalComponent } from './customer-vehicle-search-screen-action-setting-modal.component';
import { CustomerVehicleSearchScreenActionSettingService } from './customer-vehicle-search-screen-action-setting-modal.service';

/**
 * 顧客車両検索画面動作設定モジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    TooltipModule
  ],
  declarations: [
    CustomerVehicleSearchScreenActionSettingModalComponent
  ],
  entryComponents: [
    CustomerVehicleSearchScreenActionSettingModalComponent
  ],
})
export class CustomerVehicleSearchScreenActionSettingModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CustomerVehicleSearchScreenActionSettingModule,
      providers: [
        CustomerVehicleSearchScreenActionSettingService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/customer-vehicle-search-screen-action-setting-modal/customer-vehicle-search-screen-action-setting-modal.module.ts